// Init do PostHog no navegador. Vem no fim do page_context.js, que o snippet em
// app/views/shared/analytics/_posthog.html.erb carrega com async: a página não espera por ele.
// O filtro, a máscara da gravação e a identificação vêm antes no mesmo arquivo, então existem
// quando o init roda. Até aqui o snippet só enfileira capture/identify/reset, e o posthog-js repassa
// a fila depois do init, já com o before_send.
//
// Sem este arquivo (bloqueado, falha da CDN) não há init: o posthog-js nem é baixado, nada sai e a
// gravação não liga. A configuração de cada página vem do servidor no
// data-configuration da tag que carrega este arquivo (<script id="posthog-configuration">). ES5 puro,
// como o resto do arquivo.
(function (window, document) {
  var element = document.getElementById("posthog-configuration");
  var posthog = window.posthog;
  if (!element || !posthog || typeof posthog.init !== "function") return;

  var configuration;
  try {
    configuration = JSON.parse(element.getAttribute("data-configuration"));
  } catch (_error) {
    return;
  }
  // Fração das sessões que mede velocidade (posthog_performance.js). 0 desliga.
  var performanceSampleRate = Number(configuration.webVitalsSampleRate) || 0;

  var options = {
    api_host: configuration.host,
    ui_host: "https://us.posthog.com",
    // Só elementos marcados com data-ph-capture (ou dentro de um): o resto do clique da página é
    // ruído e o que é fato de negócio já sai do servidor. data-ph-capture-attribute-action dá ao
    // evento um nome que não muda quando o texto do botão muda.
    autocapture: { css_selector_allowlist: ["[data-ph-capture]"] },
    capture_pageview: true,
    capture_pageleave: configuration.pageleave,
    // A visita já é o $pageview (com rails_action); o *Viewed por controller e o $dead_click
    // eram ~10% dos eventos cobrados e nenhum insight salvo usava (out/2026).
    capture_dead_clicks: false,
    capture_exceptions: {
      capture_unhandled_errors: true,
      capture_unhandled_rejections: true,
      capture_console_errors: false
    },
    before_send: function (event) {
      // Fora do try: se a amostra falhar, o evento de desempenho não sai.
      if (!window.posthogPerformance.keep(event, performanceSampleRate)) return null;
      try {
        if (window.posthogCapturePolicy) event = window.posthogCapturePolicy.apply(event, configuration.capturePolicy);
      } catch (_error) {
      }
      if (!event) return event;
      try {
        return window.posthogBeforeSend(event, configuration.context);
      } catch (_error) {
        return event;
      }
    },
    capture_heatmaps: true,
    // network_timing só alimenta a gravação de sessão, que não leva nenhuma requisição. Com
    // web_vitals ligado, toda página baixa o web-vitals.js do posthog-js (com cache), e o
    // before_send descarta as sessões fora da amostra.
    capture_performance: {
      web_vitals: performanceSampleRate > 0,
      web_vitals_allowed_metrics: ["LCP", "INP", "CLS", "FCP"],
      network_timing: false
    },
    // Ligada pelo servidor (POSTHOG_SESSION_REPLAY, só com usuário logado). Quais sessões gravar
    // (erro, amostra, duração mínima) é configuração do projeto no PostHog.
    disable_session_recording: !configuration.replay,
    session_recording: window.posthogSessionRecording(),
    enable_recording_console_log: false,
    disable_surveys: true,
    advanced_disable_feature_flags: true,
    tracing_headers: [window.location.hostname],
    bootstrap: configuration.distinctId ? { distinctID: configuration.distinctId, isIdentifiedID: true } : {},
    loaded: function (client) {
      if (configuration.distinctId) {
        // Navegador ainda identificado pelo e-mail, de antes da troca para user_<id>: o PostHog não
        // aceita identificar de novo com outro id. Recomeça anônimo e identifica pelo id; o alias
        // feito antes no servidor já liga os dois à mesma pessoa.
        if (configuration.previousDistinctId && client.get_distinct_id() === configuration.previousDistinctId) {
          window.posthogReset(client);
        }
        window.posthogIdentify(client, configuration.distinctId, configuration.personProperties);
      } else if (client.get_property("$user_id")) {
        window.posthogReset(client);
      }
      try {
        window.posthogPerformance.watch(client, performanceSampleRate);
      } catch (_error) {
        // Sem medição nesta página; a identificação acima já foi feita.
      }
    }
  };

  // Página pré-renderizada pelo Chrome (menu lateral) roda antes do clique e talvez nunca seja
  // aberta: o init, e com ele o $pageview e o download do posthog-js, espera ela aparecer. Até lá
  // capture/identify só enfileiram, como antes do init.
  function start() {
    posthog.init(configuration.token, options);
  }
  if (document.prerendering) {
    document.addEventListener("prerenderingchange", start, { once: true });
  } else {
    start();
  }
})(window, document);
